import { ChangeDetectionStrategy, Component, input, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { ImageCarousel, type CarouselImage } from '../image-carousel/image-carousel';
import { Auth } from '../../services/auth/auth';
import { NeetoCalTriggerDirective } from '../../directives/neeto-cal-trigger.directive';

export type LandingFeatureHeadingSegment = Readonly<{
  text: string;
  accent?: boolean;
}>;

export type LandingFeatureAction = Readonly<{
  label: string;
  routerLink?: string;
  href?: string;
  register?: boolean;
}>;

@Component({
  selector: 'app-landing-feature-section',
  imports: [LucideAngularModule, RouterLink, ImageCarousel, NeetoCalTriggerDirective],
  templateUrl: './landing-feature-section.html',
  styleUrl: './landing-feature-section.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block',
  },
})
export class LandingFeatureSection {
  readonly headingId = input.required<string>();
  readonly headingSegments = input.required<readonly LandingFeatureHeadingSegment[]>();
  readonly leadText = input.required<string>();
  readonly bodyText = input<string | null>(null);
  readonly primaryAction = input<LandingFeatureAction | null>(null);
  readonly secondaryAction = input<LandingFeatureAction | null>(null);
  readonly showTopBorder = input(true);
  readonly showBottomBorder = input(true);
  readonly showVisual = input(true);
  readonly carouselImages = input<readonly CarouselImage[] | null>(null);
  readonly visualLabel = input('Placeholder');
  private readonly auth = inject(Auth);

  signUp(): void {
    this.auth.signUp();
  }
}
